export default "__VITE_ASSET__4e8ccc8a__"